export const COMPARISON_FULL_TABLE_MAX_ROWS = 20;

export const COMPARISON_FULL_TABLE_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'comparison-full-table-layout',
  PLACEHOLDER_HEADING: 'Enter heading',
  PLACEHOLDER_FEATURE: 'Feature',
  PLACEHOLDER_VALUE: 'Value',
  PLACEHOLDER_NOT_AVAILABLE: 'Not available',
  DEFAULT_TOPFAN_LABEL: 'TOPFAN',
  DEFAULT_COMPETITOR_LABEL: 'Competitor',
  DEFAULT_COLUMN_LABEL_PREFIX: 'Column',
  LABEL_FEATURE: 'Feature'
} as const;
